import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { fetchEndpoint } from '../../../../_app/middleware/fetch';
import SchoolRegistration from './SchoolRegistration/containers/SchoolRegistration';
import RFPThankYou from './RFPThankYou';
import { PricingContainer } from './Pricing/index';

const pages = [PricingContainer, SchoolRegistration, RFPThankYou];
class OnboardingContainer extends Component {
  state = {
    page: 0,
  };

  nextPage = () => {
    const { page } = this.state;
    this.setState({ page: page + 1 });
  };

  previousPage = () => {
    const { page } = this.state;
    this.setState({ page: page - 1 });
  };

  startFromBeginning = () => {
    this.setState({ page: 0 });
  };

  submitForm() {
    this.props.onSubmit({
      email: this.state.email,
      password: this.state.password,
    });
  }

  getOnboardingState() {
    return {
      user: { hasVerifiedEmail: true },
      onboarding: {
        step: 1,
        form: {},
      },
    };
  }

  render() {
    const { page } = this.state;
    const CurrentPage = pages[page];
    return (
      <CurrentPage
        nextPage={this.nextPage}
        previousPage={this.previousPage}
        startFromBeginning={this.startFromBeginning}
      />
    );
  }
}

const mapStateToProps = state => ({
  // user: state.user
});

const mapDispatchToProps = dispatch => ({
  onSubmit: ({ email, password }) =>
    dispatch(
      fetchEndpoint({ url: '/createAccount', data: { email, password } })
    ), // TODO: more declarative middleware
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OnboardingContainer);



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/OnboardingContainer.jsx